import { Skeleton } from 'ui/components/primitives';
import { Checkout } from './CheckoutSkeleton.styles';
import { SKELETON_CHECKOUT_CONST } from './CheckoutSkeleton.d';

const CheckoutSkeleton = () => (
  <Checkout.Container data-testid={SKELETON_CHECKOUT_CONST.TEST_ID}>
    <Checkout.Title>
      <Skeleton />
    </Checkout.Title>

    <Checkout.Component>
      <Checkout.RadioGroup>
        <Skeleton />
      </Checkout.RadioGroup>

      <Checkout.RadioGroup>
        <Skeleton />
      </Checkout.RadioGroup>

      <Checkout.RadioGroup>
        <Skeleton />
      </Checkout.RadioGroup>
    </Checkout.Component>

    <Checkout.Button>
      <Skeleton />
    </Checkout.Button>
  </Checkout.Container>
);

export default CheckoutSkeleton;
